<template>
  <report-main @back="goBack">
    <template slot="nav">
      <div class="reportNav">
        <span v-if="reportForm.is_special_train === 1">【快】</span>
        <p>{{reportForm.name}}</p>
      </div>
    </template>
    <template slot="main">
      <div class="reportMain">
        <div class="content">
          <div class="scrollArea">
            <vue-scroll :ops="ops">
              <el-form :model="reportForm"
                       :rules="rules"
                       ref="reportForm"
                       class="reportForm"
                       label-position="top"
                       size="medium">
                <fieldset class="report-form-fieldset">
                  <legend>教练员培训班报告</legend>
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="培训班整体情况反馈:"
                                    prop="tissue_situation"
                                    class="item">
                        <el-input
                            type="textarea"
                            v-model="reportForm.tissue_situation"
                            :maxlength="len"
                            :rows="4"
                            placeholder="请输入培训班整体情况">
                        </el-input>
                        <span class="len">{{reportForm.tissue_situation.length}}/{{len}}</span>
                      </el-form-item>
                    </el-col>
                  </el-row>
  
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="学员整体情况描述:"
                        prop="student_situation"
                        class="item">
                        <el-input
                          type="textarea"
                          v-model="reportForm.student_situation"
                          :maxlength="len"
                          :rows="4"
                          placeholder="请输入学员整体情况描述">
                        </el-input>
                        <span class="len">{{reportForm.student_situation.length}}/{{len}}</span>
                      </el-form-item>
                    </el-col>
                    <el-col :span="11" :offset="1">
                      <el-form-item label=" " class="item setScore">
                        <el-form-item label="学员整体是否达到参加该级别培训的水准"
                          prop="student_situation_socre"
                          :rules="{required: true,validator: (rule, value, callback) => {validateScore(rule, value, callback)}, trigger: 'change'}" >
                          <div class="demonstration">
                            <el-input v-model.number="reportForm.student_situation_socre " style="display:none"></el-input>
                            <el-rate
                              v-model.number="reportForm.student_situation_socre ">
                            </el-rate>
                          </div>
                        </el-form-item>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="场地设施器材情况反馈:"
                        prop="facility_situation"
                        class="item">
                        <el-input
                          type="textarea"
                          v-model="reportForm.facility_situation"
                          :maxlength="len"
                          :rows="4"
                          placeholder="请输入场地设施器材情况">
                        </el-input>
                        <span class="len">{{reportForm.facility_situation.length}}/{{len}}</span>
                      </el-form-item>
                    </el-col>
                    <el-col :span="11" :offset="1" >
                      <el-form-item label=" " class="item setScore">
                        <el-form-item label="对理论课教室的满意度"
                          prop="theory_room_score"
                          :rules="{required: true,validator: (rule, value, callback) => {validateScore(rule, value, callback)}, trigger: 'change'}" >
                          <div class="demonstration">
                            <el-input v-model.number="reportForm.theory_room_score " style="display:none"></el-input>
                            <el-rate v-model.number="reportForm.theory_room_score "></el-rate>
                          </div>
                        </el-form-item>
                        
                        <el-form-item label="对实践课场地的满意度"
                          prop="practice_room_score"
                          :rules="{required: true,validator: (rule, value, callback) => {validateScore(rule, value, callback)}, trigger: 'change'}">
                          <div class="demonstration">
                            <el-input v-model.number="reportForm.practice_room_score " style="display:none"></el-input>
                            <el-rate v-model.number="reportForm.practice_room_score "></el-rate>
                          </div>
                        </el-form-item>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="器材情况反馈:"
                                    prop="equipment_situation"
                                    class="item">
                        <el-input
                            type="textarea"
                            v-model="reportForm.equipment_situation"
                            :maxlength="len"
                            :rows="4"
                            placeholder="请输入器材情况">
                        </el-input>
                        <span class="len">{{reportForm.equipment_situation.length}}/{{len}}</span>
                      </el-form-item>
                    </el-col>
                    <el-col :span="11" :offset="1" >
                      <el-form-item label=" " class="item setScore">
                        <el-form-item label="对相关器材满意度"
                          prop="equipment_score"
                          :rules="{required: true,validator: (rule, value, callback) => {validateScore(rule, value, callback)}, trigger: 'change'}">
                          <div class="demonstration">
                            <el-input v-model.number="reportForm.equipment_score " style="display:none"></el-input>
                            <el-rate v-model.number="reportForm.equipment_score "></el-rate>
                          </div>
                        </el-form-item>
                        <el-form-item label="对学员装备配置的满意度"
                          prop="equipment_student_score"
                          :rules="{required: true,validator: (rule, value, callback) => {validateScore(rule, value, callback)}, trigger: 'change'}">
                          <div class="demonstration">
                            <el-input v-model.number="reportForm.equipment_student_score " style="display:none"></el-input>
                            <el-rate v-model.number="reportForm.equipment_student_score "></el-rate>
                          </div>
                        </el-form-item>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="食宿情况反馈:"
                        prop="eating_situation"
                        class="item">
                        <el-input
                          type="textarea"
                          v-model="reportForm.eating_situation"
                          :maxlength="len"
                          :rows="4"
                          placeholder="请输入食宿情况">
                        </el-input>
                        <span class="len">{{reportForm.eating_situation.length}}/{{len}}</span>
                      </el-form-item>
                    </el-col>
                    <el-col :span="11" :offset="1">
                      <el-form-item label=" " class="item setScore">
                        <el-form-item label="对培训期间餐饮条件满意度"
                          prop="eat_score"
                          :rules="{required: true,validator: (rule, value, callback) => {validateScore(rule, value, callback)}, trigger: 'change'}">
                          <div class="demonstration">
                            <el-input v-model.number="reportForm.eat_score " style="display:none"></el-input>
                            <el-rate v-model.number="reportForm.eat_score "></el-rate>
                          </div>
                        </el-form-item>
                        <el-form-item label="对培训期间住宿条件满意度"
                          prop="sleep_score"
                          :rules="{required: true,validator: (rule, value, callback) => {validateScore(rule, value, callback)}, trigger: 'change'}">
                          <div class="demonstration">
                            <el-input v-model.number="reportForm.sleep_score " style="display:none"></el-input>
                            <el-rate v-model.number="reportForm.sleep_score "></el-rate>
                          </div>
                        </el-form-item>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="交通情况:"
                                    prop="traffic_situation"
                                    class="item">
                        <el-input
                            type="textarea"
                            v-model="reportForm.traffic_situation"
                            :maxlength="len"
                            :rows="4"
                            placeholder="请输入培训地的交通情况">
                        </el-input>
                        <span class="len">{{reportForm.traffic_situation.length}}/{{len}}</span>
                      </el-form-item>
                    </el-col>
                    <el-col :span="11" :offset="1">
                      <el-form-item label=" " class="item setScore">
                        <el-form-item label="培训期间是否需要用车往返培训场地"
                          prop="is_use_car">
                          <el-input v-model="reportForm.is_use_car " style="display:none"></el-input>
                            <el-radio v-model="reportForm.is_use_car " label="1" border>是</el-radio>
                            <el-radio v-model="reportForm.is_use_car " label="0" border>否</el-radio>
                        </el-form-item>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row v-if="isHighClass && ['train','physical_train','goalkeeper_train'].includes(classTrainType)">
                    <el-col :span="12">
                      <el-form-item label="实践队情况:"
                        prop="practice_team_eva"
                        :rules="[{required: true, message: '请输入实践队情况', trigger: 'blur'}]"
                        class="item">
                        <el-input
                          type="textarea"
                          v-model="reportForm.practice_team_eva"
                          :maxlength="len"
                          :rows="4"
                          placeholder="请输入实践队情况">
                        </el-input>
                        <span class="len">{{reportForm.practice_team_eva.length}}/{{len}}</span>
                      </el-form-item>
                    </el-col>
                    <el-col :span="11" :offset="1">
                      <el-form-item label=" " class="item setScore">
                        <el-form-item label="对培训实践队的整体满意度"
                          prop="practice_team_eva_score"
                          :rules="{required: true,validator: (rule, value, callback) => {validateScore(rule, value, callback)}, trigger: 'change'}" >
                          <div class="demonstration">
                            <el-input v-model.number="reportForm.practice_team_eva_score " style="display:none"></el-input>
                            <el-rate
                              v-model.number="reportForm.practice_team_eva_score ">
                            </el-rate>
                          </div>
                        </el-form-item>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row v-if="['train','physical_train','goalkeeper_train'].includes(classTrainType)">
                    <el-col :span="12">
                      <el-form-item label="自我评价:"
                        prop="myself_eva"
                        :rules="[{required: true, message: '请输入自我评价', trigger: 'blur'}]"
                        class="item">
                        <el-input
                          type="textarea"
                          v-model="reportForm.myself_eva"
                          :maxlength="len"
                          :rows="4"
                          placeholder="请输入自我评价">
                        </el-input>
                        <span class="len">{{reportForm.myself_eva.length}}/{{len}}</span>
                      </el-form-item>
                    </el-col>
                    <el-col :span="11" :offset="1">
                      <el-form-item label=" " class="item setScore">
                        <el-form-item label="对自我表现的满意度"
                          prop="myself_eva_score"
                          :rules="{required: true,validator: (rule, value, callback) => {validateScore(rule, value, callback)}, trigger: 'change'}" >
                          <div class="demonstration">
                            <el-input v-model.number="reportForm.myself_eva_score " style="display:none"></el-input>
                            <el-rate
                              v-model.number="reportForm.myself_eva_score ">
                            </el-rate>
                          </div>
                        </el-form-item>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row v-if="['train','physical_train','goalkeeper_train'].includes(classTrainType)">
                    <el-col :span="24">
                      <el-form-item label="对助理讲师的评价:"
                        prop="assistant_teacher_evaluate"
                        class="item">
                        <el-input
                          type="textarea"
                          v-model="reportForm.assistant_teacher_evaluate"
                          :maxlength="len"
                          :rows="4"
                          placeholder="请输入对助理讲师的评价">
                        </el-input>
                        <span class="len">{{reportForm.assistant_teacher_evaluate.length}}/{{len}}</span>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row v-if="is_has_teacher_zhuli">
                    <el-col :span="24">
                      <el-form-item label="对讲师助理的评价:"
                        prop="teacher_zhuli_evaluate"
                        class="item">
                        <el-input
                          type="textarea"
                          v-model="reportForm.teacher_zhuli_evaluate"
                          :maxlength="len"
                          :rows="4"
                          placeholder="请输入对讲师助理的评价">
                        </el-input>
                        <span class="len">{{reportForm.teacher_zhuli_evaluate.length}}/{{len}}</span>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row v-if="isHighClass && ['train'].includes(classTrainType)">
                    <el-col :span="12">
                      <el-form-item label="对守门员专项讲师的反馈及建议:"
                        prop="goalkeeper_teacher_eva"
                        :rules="[{required: true, message: '请输入对守门员专项讲师的反馈及建议', trigger: 'blur'}]"
                        class="item">
                        <el-input
                          type="textarea"
                          v-model="reportForm.goalkeeper_teacher_eva"
                          :maxlength="len"
                          :rows="4"
                          placeholder="请输入对守门员专项讲师的反馈及建议">
                        </el-input>
                        <span class="len">{{reportForm.goalkeeper_teacher_eva.length}}/{{len}}</span>
                      </el-form-item>
                    </el-col>
                    <el-col :span="11" :offset="1">
                      <el-form-item label=" " class="item setScore">
                        <el-form-item label="对守门员专项讲师的整体满意度"
                          prop="goalkeeper_teacher_eva_score"
                          :rules="{required: true,validator: (rule, value, callback) => {validateScore(rule, value, callback)}, trigger: 'change'}" >
                          <div class="demonstration">
                            <el-input v-model.number="reportForm.goalkeeper_teacher_eva_score " style="display:none"></el-input>
                            <el-rate
                              v-model.number="reportForm.goalkeeper_teacher_eva_score ">
                            </el-rate>
                          </div>
                        </el-form-item>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row v-if="isHighClass && ['train'].includes(classTrainType)">
                    <el-col :span="12">
                      <el-form-item label="对体能专项讲师的反馈及建议:"
                        prop="physical_teacher_eva"
                        :rules="[{required: true, message: '请输入对体能专项讲师的反馈及建议', trigger: 'blur'}]"
                        class="item">
                        <el-input
                          type="textarea"
                          v-model="reportForm.physical_teacher_eva"
                          :maxlength="len"
                          :rows="4"
                          placeholder="请输入对体能专项讲师的反馈及建议">
                        </el-input>
                        <span class="len">{{reportForm.physical_teacher_eva.length}}/{{len}}</span>
                      </el-form-item>
                    </el-col>
                    <el-col :span="11" :offset="1">
                      <el-form-item label=" " class="item setScore">
                        <el-form-item label="对体能专项讲师的整体满意度"
                          prop="physical_teacher_eva_score"
                          :rules="{required: true,validator: (rule, value, callback) => {validateScore(rule, value, callback)}, trigger: 'change'}" >
                          <div class="demonstration">
                            <el-input v-model.number="reportForm.physical_teacher_eva_score " style="display:none"></el-input>
                            <el-rate
                              v-model.number="reportForm.physical_teacher_eva_score ">
                            </el-rate>
                          </div>
                        </el-form-item>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row v-if="isHighClass && ['train','physical_train','goalkeeper_train'].includes(classTrainType)">
                    <el-col :span="24">
                      <el-form-item label="对其他专项、专题讲师的反馈及建议:"
                        prop="other_teacher_eva"
                        :rules="[{required: true, message: '请输入对其他专项、专题讲师的反馈及建议', trigger: 'blur'}]"
                        class="item">
                        <el-input
                          type="textarea"
                          v-model="reportForm.other_teacher_eva"
                          :maxlength="len"
                          :rows="4"
                          placeholder="请输入对其他专项、专题讲师的反馈及建议">
                        </el-input>
                        <span class="len">{{reportForm.other_teacher_eva.length}}/{{len}}</span>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row v-if="['train','physical_train','goalkeeper_train'].includes(classTrainType)">
                    <el-col :span="12">
                      <el-form-item label="对协调员的反馈及建议:"
                        prop="link_man_eva"
                        :rules="[{required: true, message: '请输入对协调员的反馈及建议', trigger: 'blur'}]"
                        class="item">
                        <el-input
                          type="textarea"
                          v-model="reportForm.link_man_eva"
                          :maxlength="len"
                          :rows="4"
                          placeholder="请输入对协调员的反馈及建议">
                        </el-input>
                        <span class="len">{{reportForm.link_man_eva.length}}/{{len}}</span>
                      </el-form-item>
                    </el-col>
                    <el-col :span="11" :offset="1">
                      <el-form-item label=" " class="item setScore">
                        <el-form-item label="对协调员的整体满意度"
                          prop="link_man_eva_score"
                          :rules="{required: true,validator: (rule, value, callback) => {validateScore(rule, value, callback)}, trigger: 'change'}" >
                          <div class="demonstration">
                            <el-input v-model.number="reportForm.link_man_eva_score " style="display:none"></el-input>
                            <el-rate
                              v-model.number="reportForm.link_man_eva_score ">
                            </el-rate>
                          </div>
                        </el-form-item>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row v-if="['train','physical_train','goalkeeper_train'].includes(classTrainType)">
                    <el-col :span="12">
                      <el-form-item :label="isHighClass ? '对培训承办机构的反馈及建议' :'对培训主办机构的反馈及建议'"
                        prop="organ_eva"
                        :rules="[{required: true, message: isHighClass ? '请输入对培训承办机构的反馈及建议' :'请输入对培训主办机构的反馈及建议', trigger: 'blur'}]"
                        class="item">
                        <el-input
                          type="textarea"
                          v-model="reportForm.organ_eva"
                          :maxlength="len"
                          :rows="4"
                          :placeholder="isHighClass ? '请输入对培训承办机构的反馈及建议' :'请输入对培训主办机构的反馈及建议'">
                        </el-input>
                        <span class="len">{{reportForm.organ_eva.length}}/{{len}}</span>
                      </el-form-item>
                    </el-col>
                    <el-col :span="11" :offset="1">
                      <el-form-item label=" " class="item setScore">
                        <el-form-item :label="isHighClass ? '对培训承办机构的整体满意度' :'对培训主办机构的整体满意度'"
                          prop="organ_eva_score"
                          :rules="{required: true,validator: (rule, value, callback) => {validateScore(rule, value, callback)}, trigger: 'change'}" >
                          <div class="demonstration">
                            <el-input v-model.number="reportForm.organ_eva_score " style="display:none"></el-input>
                            <el-rate
                              v-model.number="reportForm.organ_eva_score ">
                            </el-rate>
                          </div>
                        </el-form-item>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row v-if="['train','physical_train','goalkeeper_train'].includes(classTrainType)">
                    <el-col :span="12">
                      <el-form-item label="对未来培训工作的建议:"
                                    prop="class_suggest"
                                    class="item">
                        <el-input
                            type="textarea"
                            v-model="reportForm.class_suggest"
                            :maxlength="len"
                            :rows="4"
                            placeholder="请输入对未来培训工作的建议">
                        </el-input>
                        <span class="len">{{reportForm.class_suggest.length}}/{{len}}</span>
                      </el-form-item>
                    </el-col>
                    <el-col :span="11" :offset="1">
                      <el-form-item label="其他意见及建议:"
                        prop="remark"
                        class="item">
                        <el-input
                          type="textarea"
                          v-model="reportForm.remark"
                          :maxlength="len"
                          :rows="4"
                          placeholder="请输入其他意见及建议">
                        </el-input>
                        <span class="len">{{reportForm.remark.length}}/{{len}}</span>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row v-else>
                    <el-col :span="24">
                      <el-form-item label="其他意见及建议:"
                        prop="remark"
                        class="item">
                        <el-input
                          type="textarea"
                          v-model="reportForm.remark"
                          :maxlength="len"
                          :rows="4"
                          placeholder="请输入其他意见及建议">
                        </el-input>
                        <span class="len">{{reportForm.remark.length}}/{{len}}</span>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </fieldset>
                <template v-if="reportForm.studentFail.length">
                  <fieldset class="report-form-fieldset">
                    <legend>学员培训未通过<span v-if="!['D','C','early','GC'].includes(classLevel)">或补考</span>详细原因</legend>
                    <el-form-item

                      v-for="(item, index) in reportForm.studentFail"
                      :prop="'studentFail.' + index + '.reason_info'"
                      :rules="{required: true, message: `请输入详细原因`, trigger: `blur`}"
                      class="item"
                      :key="index"
                    >
                      <div class="failImg">
                        <img :src="item.profile_picture || person " alt=""  style="width: 70px;height: 70px;border-radius: 50%" @error="imgErr1(index)">
                        <p >{{item.name}}</p>
                        <p style="color:#f88594">({{item.results_status === 'practice_make_up' ? '实践考试补考' : '未通过'}})</p>
                      </div>
                      <el-input
                        placeholder="在学员对收到的培训结果产生异议并进行申诉的情况下，本部分内容将被中国足协作为处理申诉的参考依据。请主讲师详细和客观填写。"
                        v-model="item.reason_info"
                        type="textarea"
                        :maxlength="500"
                        :rows="3"
                      >
                      </el-input>
                      <span class="len fail">{{item.reason_info ? item.reason_info.length : 0 }}/500</span>
                    </el-form-item>
                  </fieldset>
                </template>
                <template v-if="reportForm.teacher_eva.length">
                  <fieldset class="report-form-fieldset">
                    <legend>助理讲师评价表</legend>
                    <el-row v-if="showTemplate" >
                      <el-col :span="20">
                        <div class="tea-row" v-for="(item, index) in reportForm.teacher_eva">
                          <div class="left">
                            <div class="userImg">
                              <img :src="item.profile_picture || person"
                                   @error="imgErr(index)"
                                   alt="">
                            </div>
                            <div class="userInfo">
                              <p>姓名：{{item.name}}</p>
                              <p>手机号：{{item.mobile_phone}}</p>
                            </div>
                          </div>
                          <div class="right" >
                            <template v-if="item.has_eva === 1">
                              <upload-file :fileUrl.sync="item.tea_eva_url"></upload-file>
                              <div class="download">
                                <a v-if="item.tea_eva_url"
                                   :href="item.tea_eva_url"
                                   download="">
                                  <el-button type="primary">查看</el-button>
                                </a>
                              </div>
                            </template>
                            <template v-if="item.has_record === 1">
                              <div>
                                <el-button @click="getTemplate(item.teacher_id,item)" type="primary" :loading="item.loading" :disabled="item.loading" style="width: 110px">{{item.record_status==='complete' ? '查看/编辑' : '添加'}}</el-button>
                                <span v-if="item.record_status==='complete'" class="status_comment sucess">已提交</span>
                                <span v-if="item.record_status==='incomplete'||item.record_status===''" class="status_comment err">未提交</span>
                              </div>
                            </template>
                          </div>
                        </div>
                      </el-col>
                      <el-col v-if="isFive" :span="3" :offset="1" >
                        <a href="/uploads/import_tpl/中国足协五人制足球教练员讲师评价表.docx" download="中国足协五人制足球教练员讲师评价表.docx" style="display:blcok;">
                          <el-button type="primary">下载模板</el-button>
                        </a>
                      </el-col>
                      <el-col v-else :span="3" :offset="1" >
                        <a href="/uploads/import_tpl/中国足协讲师评价表.docx" download="中国足协讲师评价表.docx" style="display:blcok;">
                          <el-button type="primary">下载模板</el-button>
                        </a>
                      </el-col>
                    </el-row>
                      <el-row v-else >
                          <el-col :span="24">
                              <div class="tea-row" v-for="(item, index) in reportForm.teacher_eva">
                                  <div class="left">
                                      <div class="userImg">
                                          <img :src="item.profile_picture || person"
                                               @error="imgErr(index)"
                                               alt="">
                                      </div>
                                      <div class="userInfo">
                                          <p>姓名：{{item.name}}</p>
                                          <p>手机号：{{item.mobile_phone}}</p>
                                      </div>
                                  </div>
                                  <div class="right comment">
                                      <template v-if="item.has_eva === 1">
                                          <upload-file :fileUrl.sync="item.tea_eva_url"></upload-file>
                                          <div class="download">
                                              <a v-if="item.tea_eva_url"
                                                 :href="item.tea_eva_url"
                                                 download="">
                                                  <el-button type="primary">查看</el-button>
                                              </a>
                                          </div>
                                      </template>
                                      <template v-if="item.has_record === 1">
                                          <div >
                                              <el-button @click="getTemplate(item.teacher_id,item)" type="primary" :loading="item.loading" :disabled="item.loading" style="width: 110px">{{item.record_status==='complete' ? '查看/编辑' : '添加'}}</el-button>
                                            <span v-if="item.record_status==='complete'" class="status_comment success" >已提交</span>
                                            <span v-if="item.record_status==='incomplete'||item.record_status===''" class="status_comment err">未提交</span>
                                          </div>
                                      </template>
                                  </div>
                              </div>
                          </el-col>
                      </el-row>
                  </fieldset>
                </template>
              </el-form>
            </vue-scroll>
          </div>
        </div>
        <div class="btns">
          <div v-if="showUploadBtn"
               class="btn success"
               @click="upReport">提交审核
          </div>
          <div class="btn success"
               @click="tempUpload">{{(role_type === 'teacher' || role_type === 'teaFive') ? '暂时保存' : '保存' }}
          </div>
          <div class="btn success"
               @click="preStep">上一步
          </div>
          <div class="btn error"
               @click="cancelBack">取消
          </div>
        </div>
        <yioks-tips :tips="backWarn.tips"
                    :showTips="backWarn.flag"
                    @hideTips="hideBackTips"></yioks-tips>
        <yioks-tips :tips="uploadWarn.tips"
                    :showTips="uploadWarn.flag"
                    :loading="loading"
                    @hideTips="hideUploadTips"></yioks-tips>
        <yioks-tips :tips="tempSaveWarn.tips"
                    :showTips="tempSaveWarn.flag"
                    :loading="loading"
                    @hideTips="hideTempUploadTips"></yioks-tips>
        <yioks-tips :tips="preWarn.tips"
                    :showTips="preWarn.flag"
                    :loading="loading"
                    @hideTips="hidePreTips"></yioks-tips>
        <yioks-tips :tips="cancelWarn.tips"
                    :showTips="cancelWarn.flag"
                    @hideTips="hideCanCelTips"></yioks-tips>
        <promote-subject
                :showTips="showProSubject"
                :teacher_eva="reportForm.teacher_eva"
                :theory_info.sync="theory_info"
                :template_title="template_title"
                :teacher_id="this.teacher_id"
                :user_name="this.user_name"
                :promote_number="this.promote_number"
                :promote_level="this.promote_level"
                @hideTips="hidePromoteSubject"></promote-subject>
      </div>
    </template>
  </report-main>
</template>

<script>
  import ops from '@/assets/js/vuescrollOption';
  import person from "@/assets/images/person.png";
  import {getReportInfo, uploadReport,promote_record_data,promote_template_data} from "@/api/training_teacher/api";
  import {storageData} from "@/assets/js/storage";
  import fiveMixins from '@/minix/fiveMixins';

  let {entries} = Object;
  const role_type=storageData.getUserType();
  export default {
    name: "class-report",
    mixins: [fiveMixins],
    data() {
      const uploadWarn = {
        flag: false,
        tips: "确定提交审核吗？"
      };
      const tempSaveWarn = {
        flag: false,
        tips: role_type === 'teacher' ? "确定暂时保存吗？" : "确定保存吗？"
      };
      const preWarn = {
        flag: false,
        tips: "确定保存，并返回上一步吗?"
      };
      const backWarn = {
        flag: false,
        tips: "确定放弃修改并返回吗？"
      };
      const cancelWarn = {
        flag: false,
        tips: "确定放弃修改并返回吗？"
      };
      const len = 500;
      const rules = {
        tissue_situation: [
          {required: true, message: '请输入培训班组织情况', trigger: 'blur'},
          {min: 1, max: len, message: `长度在 1 到 ${len} 个字符`, trigger: 'blur'}
        ],
        facility_situation: [
          {required: true, message: '请输入设施情况', trigger: 'blur'},
          {min: 1, max: len, message: `长度在 1 到 ${len} 个字符`, trigger: 'blur'}
        ],
        equipment_situation: [
          {required: true, message: '请输入器材装备情况', trigger: 'blur'},
          {min: 1, max: len, message: `长度在 1 到 ${len} 个字符`, trigger: 'blur'}
        ],
        student_situation: [
          {required: true, message: '请输入学员情况', trigger: 'blur'},
          {min: 1, max: len, message: `长度在 1 到 ${len} 个字符`, trigger: 'blur'}
        ],
        eating_situation: [
          {required: true, message: '请输入食宿条件情况', trigger: 'blur'},
          {min: 1, max: len, message: `长度在 1 到 ${len} 个字符`, trigger: 'blur'}
        ],
        traffic_situation: [
          {required: true, message: '请输入交通情况', trigger: 'blur'},
          {min: 1, max: len, message: `长度在 1 到 ${len} 个字符`, trigger: 'blur'}
        ],
        assistant_teacher_evaluate: [
          {required: true, message: '请输入对助理讲师的评价', trigger: 'blur'},
          {min: 1, max: len, message: `长度在 1 到 ${len} 个字符`, trigger: 'blur'}
        ],
        teacher_zhuli_evaluate: [
          {required: true, message: '请输入对讲师助理的评价', trigger: 'blur'},
          {min: 1, max: len, message: `长度在 1 到 ${len} 个字符`, trigger: 'blur'}
        ],
        class_suggest: [
          {required: true, message: '请输入对未来培训班的建议', trigger: 'blur'},
          {min: 1, max: len, message: `长度在 1 到 ${len} 个字符`, trigger: 'blur'}
        ],
        remark: [
          {required: false, message: '请输入备注', trigger: 'blur'},
          {min: 1, max: len, message: `长度在 1 到 ${len} 个字符`, trigger: 'blur'}
        ],
        is_use_car: [{required: true, message: "请选择培训地的交通情况", trigger: 'change'}]
      };
      const validateScore= (rule, value, callback) => {
        value=Number(value);
        if (!value) {
          callback(new Error('请选择分数'));
        } else {
          callback();
        }
      };
      return {
        ops: ops(),
        person,
        uploadWarn,
        tempSaveWarn,
        preWarn,
        backWarn,
        cancelWarn,
        len,
        validateScore,
        role_type:role_type,
        showProSubject:false, //是否显示升迁表
        theory_info:{}, //首次传入理论课评价信息
        teacher_id:'', //讲师id
        user_name:'',// 讲师姓名
        promote_number:1,
        promote_level:"D",
        template_title:{}, //弹出框标题模板
        btnLoading:false, //评价按钮loading
        showTemplate:false, //是否显示下载模板
        uploadUrl: "/api/organization/upload_teacher_eva.json",
        repeatSubmit: false,
        showUploadBtn: false,
        isHighClass:false,
        classTrainType:"",
        is_has_teacher_zhuli:"",
        classLevel:"",
        reportForm: {
          tissue_situation: "", // 培训班组织情况
          facility_situation: "", // 设施情况
          equipment_situation: "", // 器材装备情况
          student_situation: "", // 学员情况
          student_situation_socre: 0, // 学员情况评分
          theory_room_score: 0, // 理论课教室评分
          practice_room_score: 0, // 实践课教室评分
          equipment_score: 0, // 器材评分
          equipment_student_score: 0, // 学员装备配置评分
          eat_score: 0, // 住宿条件评分
          is_use_car: "", // 是否需要用车往返
          link_man_eva_score: 0, // 对协调员的评分
          link_man_eva: "", // 对协调员的评价
          goalkeeper_teacher_eva_score: 0, // 对守门员专项讲师的评分
          goalkeeper_teacher_eva: "", // 对守门员专项讲师的评价
          myself_eva_score: 0, // 自我评价评分
          myself_eva: "", // 自我评价
          practice_team_eva_score: 0, // 对实践队评分
          practice_team_eva: "", // 对实践队评价
          sleep_score: 0, // 学员装备配置评分
          physical_teacher_eva: "", // 对体能专项讲师的评价
          physical_teacher_eva_score: 0, // 对体能专项讲师的评分
          other_teacher_eva: "", // 对其他专项讲师的评价
          other_teacher_eva_score: 0, // 对其他专项讲师的评分
          organ_eva: "", // 对会员协会的评价
          organ_eva_score: 0, // 对会员协会的评分
          
          eating_situation: "", // 食宿条件情况
          traffic_situation: "", // 交通情况
          assistant_teacher_evaluate: "", // 对助理讲师的评价
          teacher_zhuli_evaluate: "", // 对讲师助理的评价
          class_suggest: "", // 对未来培训班的建议
          remark: "", // 备注
          status: "", // 保存状态  提交审核 or 暂时保存（Audit  or  Edit）
          teacher_eva: [], // 讲师评价 文件数据 teacher_id : 讲师id report_url: 文件路径
          studentFail:[],
          c_id: this.$route.query.c_id,
        },
        rules,
        loading: false,
      };
    },
    components: {
      "report-main": () => import("@/components/LayOut/Common/up-down"),
      "yioks-tips": () => import("@/components/Tips/Dialog"),
      "upload-file": () => import("@/components/score/components/upload-file"),
      "promote-subject":() => import("@/components/score/promote-subject")
    },
    created() {
      this.getReportData();
    },
    methods: {
      check() {
        let checkBool = false;
        let checkComemnt=false;
        this.$refs["reportForm"].validate((valid) => {
          if (valid) {
            checkBool = true;
            // 检验是否上传文件
            checkComemnt=true;
            //检验是否填写助理讲师评价
            this.reportForm.teacher_eva.map((item) => {
              if (!item.tea_eva_url && item.has_eva===1) {
                checkBool = false;
              }
              if( item.has_record===1 && item.record_status!='complete'  ){
                checkComemnt=false;
              }
            });
            if (!checkBool) {
              this.$message({
                type: 'error',
                message: '请上传教练员讲师评价表'
              });
            }
            if (!checkComemnt) {
              this.$message({
                type: 'error',
                message: '请填写助理讲师评价'
              });
            }
          } else {
            console.log('error submit!!');
          }
        });
        return checkBool && checkComemnt;
      },
      // 提交审核 Audit
      upReport() {
  
        this.$refs["reportForm"].validate((valid) => {
          if(!valid){
            this.$message.error('请填写所有带*号的必填项')
            return
          }
        });
        
        this.check() && this.$set(this.uploadWarn, "flag", true);
      },
      hideUploadTips(bool, flag) {
        this.$set(this.uploadWarn, "flag", bool);
        flag && this.submitReport("Audit");
      },
      // 暂时保存 Edit
      tempUpload() {
        // this.check() && this.$set(this.tempSaveWarn, "flag", true);
        this.$set(this.tempSaveWarn, "flag", true);
      },
      hideTempUploadTips(bool, flag) {
        this.$set(this.tempSaveWarn, "flag", bool);
        flag && this.submitReport("Edit");
      },
      // 上一步 Back
      preStep() {
        // this.check() && this.$set(this.preWarn, "flag", true);
        this.$set(this.preWarn, "flag", true);
      },
      hidePreTips(bool, flag) {
        this.$set(this.preWarn, "flag", bool);
        flag && this.submitReport("Back");
      },
      goBack() {
        this.$set(this.backWarn, "flag", true);
      },
      hideBackTips(bool, flag) {
        this.$set(this.backWarn, "flag", bool);
        flag && this.$router.go(-1);
      },
      cancelBack() {
        this.$set(this.cancelWarn, "flag", true);
      },
      hideCanCelTips(bool, flag) {
        this.$set(this.cancelWarn, "flag", bool);
        if(this.isFive){
          flag && this.$router.go(-3);
        } else{
          flag && this.$router.go(-2);
        }
        
      },
      // 关闭显示助理讲师升迁表弹出层
      hidePromoteSubject(bool){
        if(bool){
          console.log(1)
        }else {
          this.showProSubject=false
        }
      },
      //得到助理讲师的评价成绩，以及课题模板等
      getTemplate(id,item){
        item.loading=true;
        // this.btnLoading=true;
        this.teacher_id=id;
        this.user_name=item.name;
        promote_template_data({
          teacher_id:id,
          c_id:this.$route.query.c_id,
        }).then(res=>{
          if (res.data.status===0){
            this.template_title = res.data.result;
            this.promote_number=this.template_title.infoMap.promote_number;
            this.promote_level=this.template_title.infoMap.promote_level;
            let theory_subject_info = {};
            let practice_subject_info = {};
            if  (this.template_title){
              for (let i in this.template_title.theorySubjectData){
                theory_subject_info[this.template_title.theorySubjectData[i].subject_id] = this.template_title.theorySubjectData[i].subject_name;
              }
              for (let i in this.template_title.practiceSubjectData){
                practice_subject_info[this.template_title.practiceSubjectData[i].subject_id] = this.template_title.practiceSubjectData[i].subject_name;
              }
              this.template_title["theory_subject_info"] = theory_subject_info;
              this.template_title["practice_subject_info"] = practice_subject_info;
              this.getTeaInfo(id,item)
            }
          } else {
            this.$message.error(res.data.msg);
            item.loading=false;
          }
        }).catch(err=>{
          console.log(err)
          item.loading=false;
        });
       },
      getTeaInfo(id,item){
        promote_record_data({
          teacher_id:id,
          promote_type:'theory',
          c_id:this.$route.query.c_id,
        }).then(res=>{
          if (res.data.status===0){
            const {evaluateDate,subjectData,promote_level}=res.data.result;
            if (subjectData.length>0){
              for (let index in evaluateDate){
                evaluateDate[index].order=index+1;
                evaluateDate[index].score=Number( evaluateDate[index].score) / 2
                
              }
              //把当前的5个理论课主题在原始的主题模板中禁用
              let theory_subject_date = {};
              for (let index in subjectData){
                let result=subjectData[index].child_list;
                subjectData[index].order=index +1;
                for (let idx in result){
                  result[idx].score= Number(result[idx].score) / 2
                }
                theory_subject_date[subjectData[index].subject_id] =  subjectData[index].subject_name;
              }
              //如果5个主题在原始模板中存在，添加禁用属性
              if (this.template_title) {
                this.template_title.theorySubjectData.forEach(res => {
                  if (theory_subject_date[res.subject_id]) {
                    res.disabled = true;
                  }
                });
              }
              this.theory_info={
                evaluateDate:evaluateDate,
                subjectData:subjectData,
                teacher_id:id
              };
              console.log(this.theory_info)
              item.loading=false;
              this.showProSubject=true;
            }else{
              //定义理论课主标题 subjectData
              const {record_id}=this.template_title.infoMap; //从模板获取record_id
              const {theoryComperData}=this.template_title; //获取模板中子标题
              const subject = {
                evaluate: "",
                evaluate_id: null,
                indicators_score: "",
                record_id: record_id,
                subject_id: '',
                subject_name: "",
                subject_type: "theory",
                keyUuid: this.uuid()
              };
              
              // B和A 默认是三个
              if(this.promote_level === 'B' || this.promote_level === 'A'){
                for (let j = 0; j < 3; j++) {
                  subjectData.push({
                    ...subject,
                    child_list: this.child_list()
                  })
                }
              } else{
                // 2023.03.23修改，现在第5次自己选 理论是 选8个
                for (let j = 0; j < 8; j++) {
                  subjectData.push({
                    ...subject,
                    child_list: this.child_list()
                  })
                }
                // D级+8个 C是12个 再加4个
                if(promote_level==='C'){
                  for (let j = 0; j < 4; j++) {
                    subjectData.push({
                      ...subject,
                      child_list: this.child_list()
                    })
                  }
                }
              }
              
              //定义理论课综合表现 evaluateDate
              theoryComperData.forEach(comperData=>{
                evaluateDate.push({
                  record_id:record_id,
                  indicators_type:comperData.indicators_type,
                  indicators_name:comperData.indicators_name,
                  evaluate:'',
                  score:0,
                  indicators_id:comperData.indicators_id,
                  comprehensive_id:null,
                })
              });
              this.theory_info={
                evaluateDate:evaluateDate,
                subjectData:subjectData,
                teacher_id:id
              };
              item.loading=false;
              this.showProSubject=true;
            }
          } else{
            this.$message.error(res.data.msg);
            item.loading=false;
          }
        }).catch(err=>{
          item.loading=false;
          console.log(err)
        });
      },
      submitReport(status) {
        if (this.repeatSubmit) return;
        this.repeatSubmit = true;
        this.loading = true;
        this.$set(this.reportForm, "status", status);
        uploadReport({
          ...this.reportForm,
          teacher_eva: JSON.stringify(this.reportForm.teacher_eva),
          studentFail: JSON.stringify(this.reportForm.studentFail)
        })
          .then(({data}) => {
            this.loading = false;
            if (Number(data.status) === 0) {
              if(this.reportForm.status === "Edit"){
                this.$message.success("暂时保存成功");
              }else if( this.reportForm.status === "Audit"){
                this.$message.success("提交审核成功");
              }
              this.reportForm.status === "Back"
                ? this.$router.go(-1)
                : (this.isFive ? this.$router.go(-3) : this.$router.go(-2));
            } else {
              this.$message({
                type: "error",
                message: data.msg || "提交失败"
              });
              throw new Error(data.msg || "提交失败");
            }
          })
          .catch((err) => {
            this.loading = false;
            this.repeatSubmit = false;
            console.error(err);
          });
      },
      getReportData() {
        getReportInfo({c_id: this.reportForm.c_id})
          .then(({data}) => {
            const {isShowAudit, trainReport, teacherEvaluate,studentFail,teacherAll,classTrainType,is_has_teacher_zhuli} = data.result;
            this.showUploadBtn = isShowAudit;
            this.classTrainType = classTrainType;
            this.is_has_teacher_zhuli = is_has_teacher_zhuli;
            this.classLevel = trainReport.class_level;
            let tempReport = {};
            for (let [key, val] of entries(trainReport)) {
              val === null ? tempReport[key] = "" : tempReport[key] = val;
              if(key === 'student_situation_socre') val ? tempReport[key] = Number(val) : tempReport[key] = 0
              if(key === 'practice_room_score') val ? tempReport[key] = Number(val) : tempReport[key] = 0
              if(key === 'theory_room_score') val ? tempReport[key] = Number(val) : tempReport[key] = 0
              if(key === 'equipment_score') val ? tempReport[key] = Number(val) : tempReport[key] = 0
              if(key === 'equipment_student_score') val ? tempReport[key] = Number(val) : tempReport[key] = 0
              if(key === 'eat_score') val ? tempReport[key] = Number(val) : tempReport[key] = 0
              if(key === 'sleep_score') val ? tempReport[key] = Number(val) : tempReport[key] = 0
              if(key === 'link_man_eva_score') val ? tempReport[key] = Number(val) : tempReport[key] = 0
              if(key === 'myself_eva_score') val ? tempReport[key] = Number(val) : tempReport[key] = 0
              if(key === 'practice_team_eva_score') val ? tempReport[key] = Number(val) : tempReport[key] = 0
              if(key === 'goalkeeper_teacher_eva_score') val ? tempReport[key] = Number(val) : tempReport[key] = 0
              if(key === 'physical_teacher_eva_score') val ? tempReport[key] = Number(val) : tempReport[key] = 0
              if(key === 'other_teacher_eva_score') val ? tempReport[key] = Number(val) : tempReport[key] = 0
              if(key === 'organ_eva_score') val ? tempReport[key] = Number(val) : tempReport[key] = 0
            }
            
            if(['B','A','PRO','GB','GA','F1','F2'].includes(trainReport.class_level)){
              this.isHighClass = true;
            }
            
            let tempEva = [];
            teacherEvaluate.length && (tempEva = teacherEvaluate);
            // 判断是否显示模板
            teacherEvaluate.forEach(tea=>{
                if (tea.has_eva===1) this.showTemplate=true;
            });
            let stuFail = [];
            studentFail.length && (stuFail = studentFail);
            this.reportForm = {
              ...this.reportForm,
              ...tempReport,
              teacher_eva: tempEva,
              assistant_teacher_evaluate: teacherAll.length ? tempReport.assistant_teacher_evaluate : "无助理讲师"
            };
            this.reportForm.studentFail = stuFail.map((item) => {
              return {
                stu_id: item.stu_id,
                info_id: item.info_id ? item.info_id : 0,
                name:item.name,
                profile_picture:item.profile_picture,
                reason_info: item.reason_info ? item.reason_info : "",
                results_status: item.results_status,
              };
            })
          })
          .catch((err) => {
            console.error(err);
          });
      },
      imgErr(idx) {
        this.$set(this.reportForm.teacher_eva[idx], "profile_picture", this.person);
      },
      imgErr1(idx) {
        this.$set(this.reportForm.studentFail[idx], "profile_picture", this.person);
      },
      uuid() {
        let s = [];
        const hexDigits = "0123456789abcdef";
        for (let i = 0; i < 36; i++) {
          s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
        }
        s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
        s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
        s[8] = s[13] = s[18] = s[23] = "";
        return s.join("");
      },
      child_list(){
        const {theoryIndicatorsData}=this.template_title; //获取模板中子标题
        let childList=[];
        theoryIndicatorsData.forEach((child,index)=>{
          childList.push({
            evaluate_id:null,
            score:0,
            score_id:null,
            indicators_id:child.indicators_id,
            indicators_type:child.indicators_type,
            indicators_name:child.indicators_name,
            keyUuid:this.uuid()
          })
        });
        return childList;
      }

    }
  }
</script>


<style lang="stylus">
  @import '~@/assets/css/variable';
  .reportMain {
    .content {
      .reportForm {
        .item {
          .el-form-item__label {
            font-size: $font_size_base;
            line-height: $font_size_base;
            color: $color_white;
          }
          .el-form-item__content{
            display flex
            justify-content center
            align-items center
            .failImg{
              width 108px
              margin-left 10px
              text-align left
              margin-top 20px
              /*height 100px*/
              img{
                width 81px
                height 70px
                border-radius 50%
              }
              p{
                text-align: center;
                margin-top: -6px;
                margin-left: -15px;
                height: auto;
                line-height: 20px;
              }
            }
          }
          .el-form-item__error{
            padding-top 8px
          }
        }
        .setScore{
          .el-form-item__content{
            justify-content:space-between !important;
          }
          .is-bordered{
            color: white;
          }
        }
      }
    }
  }

</style>
<style lang="stylus" scoped>
  @import '~@/assets/css/variable';
  @import '~@/assets/css/mixin';
  .reportNav {
    flex: 1 1 auto;
    display: flex;
    align-items: center;
    font-size: $font_size_big;
  }

  .reportMain {
    width: 100%;
    height: 100%;
    .content {
      height: 92%;
      box-sizing: border-box;
      padding: 15px 0;
      background-color: $block_bg_color_base;
      .scrollArea {
        width: 100%;
        height: 100%;
        .reportForm {
          padding: 0 20px;
          .report-form-fieldset {
            margin: 0 0 20px 0;
            padding: 10px 10px 0;
            border: 1px solid $color_white;
            legend {
              font-size: $font_size_medium;
            }
          }
          .item {
            position: relative;
            .len {
              position: absolute;
              right: 6px;
              bottom: 4px;
              font-size: $font_size_base;
              line-height: $font_size_base;
              color: $color_info;
              user-select: none;
            }
            .fail{
              bottom 27px
            }
            .demonstration{
              display:block;
              text-align:center
            }
          }
          .tea-row {
            padding: 15px 20px;
            margin: 0 0 10px 0;
            display: flex;
            align-items: center;
            border: 1px solid $color_white;
            .left {
              display: flex;
              margin: 0 30px 0 0;
              .userImg {
                flex: 0 0 auto;
                display: flex;
                align-items: center;
                margin: 0 20px 0 0;
                img {
                  width: 70px;
                  height: 70px;
                  border-radius: 50%;
                }
              }
              .userInfo {
                flex: 1 1 auto;
                display: flex;
                flex-direction: column;
                justify-content: space-around;
                font-size: $font_size_medium;
              }
            }
            .right {
              flex: 1 1 auto;
              display: flex;
              justify-content: space-between;
              .btn{
                button{
                  color:$color_white
                  background-color :$color_suc
                  border  none
                }
              }
              .download {
                a {
                  display: block;
                }
              }
              .status_comment{
                margin-left 10px
                color $color_suc
              }
              .err{
                color $color_err
              }
            }
            .comment{
                justify-content center
                .status_comment{
                  margin-left 10px
                  color $color_suc
                }
                .err{
                  color $color_err
                }
            }
          }
        }
      }
    }
    .btns {
      height: 40px;
      margin: 10px 0 0;
      display: flex;
      justify-content: center;
      align-items: center;
      .btn {
        height: 100%;
        margin: 0 20px;
        padding: 8px 15px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: $font_size_medium;
        line-height: $font_size_medium;
        border-radius: 5px;
        cursor: pointer;
        user-select: none;
      }
      .success {
        background-color: $color_suc;
      }
      .error {
        background-color: $color_err;
      }
    }
  }
</style>
<style lang="stylus" scoped>
  .el-form-item__content{
    display flex
  }
</style>
